import React from "react";
import { Link } from "react-router-dom";

export default function Mundareja({ subject_id, themes, testId, setCurrrent_theme }) {
  if (!themes) return null;
  function theme_id(id, e) {
    e.preventDefault();
    setCurrrent_theme(id)

  }
  if (themes.length !== 0) {
    return (
      < div >
        <div className="text-left">
          <div className="contents">
            <b>Mundarija</b>
            {themes.map((item, index) => {

              return (
                <Link to="/textpage" className="body-content content" key={item.id} onClick={(e) => theme_id(item.id, e)} >
                  {item.title_number != 0 ? `${item.title_number}-mavzu` : "Kirish"}
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21C16.5228 21 21 16.5228 21 11Z"
                      stroke="#4ECB71"
                      strokeWidth="2"
                    />
                    <path
                      d="M9.5 15L13.5 11L9.5 7"
                      stroke="#4ECB71"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </Link>
              )
            })}
            {testId ? <Link to={`/test/${testId + "/" + subject_id}`} className="body-content content">
              Test savollari
            </Link> : null}

          </div>
        </div>

      </div >
    );
  }
  else {
    setCurrrent_theme(0)
    return (
      <div><p>Bu fanga hali mavzu qoshilmagan</p></div>
    )
  }

}
